export default __webpack_public_path__ + "static/media/tips-icon.f131a971.svg";